module.exports = __webpack_public_path__ + "img/border_rectangle2.66a22176.svg";